/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import { TrashIcon } from "@heroicons/react/24/outline";
import Button from "../material/button/Button";
// import * as adminApi from '../../../service/adminApi';
// import * as adminApi from '../../service/adminApi'
// import * as labApi from '../../service/labPersonalApi'
import * as labApi from "../../service/labPersonalApi";

import ModalAddData from "../material/modal/ModalAddData";
import moment from "moment";
import "moment/locale/th";
import { HashLoader } from "react-spinners";
import Pagination from "../pagination/Pagination";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { RedirectCode400 } from "../RedirectCode400";
import { RedirectCode400 } from "../RedirectCode400";

import { CurrentUserContext } from "../../App";
import styles from "./NewinspectionGuide.module.css";

import DataTable from "react-data-table-component";
import PageHeader from "../pageheader/PageHeader";
import Breadcrumb from "../public/breacrumb/breadcrumb";
import Footer from "../footer/Footer";
import HeadBar from "../../component/public/headBar/HeadBar";
import ModalUploadFileV3 from "../material/modal/ModalUploadFileV3";
import ModalDeleteDocument from "../material/modal/ModalDeleteDocument";
import ModalDeleteGuideline from "../material/modal/ModalDeleteGuideline";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan, faEdit } from "@fortawesome/free-solid-svg-icons";

function NewinspectionGuide() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const labUser = JSON.parse(localStorage.getItem("user"));
  const [toggle, setToggle] = useState("guide"); // document, guide
  const [documentList, setDocumentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [openModalUploadFile, setOpenModalUploadFile] = useState(false);
  const [date, setDate] = useState("");

  const [guideList, setGuideList] = useState([]);
  const [guidePage, setGuidePage] = useState(1);
  const [guideMaxPage, setGuideMaxPage] = useState(1);
  const [openModalAddData, setOpenModalAddData] = useState(false);
  const [openModalDeleteDocument, setOpenModalDeleteDocument] = useState(false);
  const [documentData, setDocumentData] = useState({});

  const [guidelineTitle, setGuidelineTitle] = useState("");
  const [guidelineDetail, setGuidelineDetail] = useState("");
  const [showDetail, setShowDetail] = useState(false);

  const [openModalDeleteGuideline, setOpenModalDeleteGuideline] =
    useState(false);
  const [guidelineData, setGuidelineData] = useState({});

  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    setDate(moment().add(543, "years").format("D MMMM YYYY"));
    if (location.state?.type) {
      setToggle(location.state?.type);
    }
  }, []);

  useEffect(() => {
    getDocumentList();
  }, [page]);

  useEffect(() => {
    getGuideline();
  }, [guidePage]);

  useEffect(() => {
    if (toggle === "document") {
      getDocumentList();
    } else if (toggle === "guide") {
      getGuideline();
    }
  }, [toggle]);

  const getDocumentList = async () => {
    setLoading(true);
    let res = await labApi.getDocument(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]);
        setDocumentList(res["data"]["document_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const showRemoveDocument = async (item) => {
    setDocumentData(item);
    setOpenModalDeleteDocument(true);
  };

  const removeDocument = async (item) => {
    // if (!window.confirm(`คุณต้องการลบ ${item.document_name} ใช่หรือไม่`)) {
    //     return;
    // }
    setLoading(true);
    let res = await labApi.removeDocument(item.document_id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setOpenModalDeleteDocument(false);
        getDocumentList();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setDocumentList([]);
    }
  };

  const addDocument = async (event) => {
    let formData = new FormData();
    formData.append("file", event.file);
    formData.append("file_name", event.inputValue);
    setLoading(true);
    let res = await labApi.addDocument(formData);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        setOpenModalUploadFile(false);
        getDocumentList();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getGuideline = async () => {
    setLoading(true);
    let res = await labApi.getGuideline(guidePage, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]);
        setGuideList(res["data"]["guideline_list"]);
        setGuideMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const addGuideline = async (title, detail) => {
    setLoading(true);
    let res = await labApi.addGuideline(title, detail);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setOpenModalAddData(false);
        getGuideline();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const showRemoveGuideline = async (item) => {
    setGuidelineData(item);
    setOpenModalDeleteGuideline(true);
  };

  const removeGuideline = async (item) => {
    // if (!window.confirm(`คุณต้องการลบ ${item["title"] || "-"} ใช่หรือไม่`)) {
    //     return;
    // }
    setLoading(true);
    let res = await labApi.removeGuideline(item["guideline_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        getGuideline();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
    setOpenModalDeleteGuideline(false);
  };

  const editGuideline = async (item) => {
    nav("/guidelineForm", {
      state: {
        ...item,
        type: "edit",
        publishStartDate: item.publish_start_date?.date,
        publishEndDate: item.publish_end_date?.date,
        pined: item.pined,
      },
    });
  };

  const columnsGuide = [
    {
      name: "ลำดับที่",
      selector: (item, index) => <div>{10 * (guidePage - 1) + 1 + index}</div>,
      width: "20%",
    },
    {
      name: "หัวข้อ",
      selector: (item) => (
        <div
          className="hover:bg-[#fff8f5] cursor-pointer text-[#000000] text-left"
          onClick={() => {
            // console.log(item);
            nav("/guidelineTextEditor", {
              state: {
                type: "view",
                title: item["title"],
                detail: item["detail"],
              },
            });
            // setGuidelineTitle(item['title'])
            // setGuidelineDetail(item['detail'])
            // setShowDetail(true)
            // setOpenModalAddData(true)
          }}
        >
          {item["title"] || "-"}
        </div>
      ),
      wrap: true,
    },
    {
      name: "เพิ่มเติม",
      selector: (item) => (
        <div className="flex justify-center">
          <TrashIcon
            onClick={() => {
              removeGuideline(item);
            }}
            className="w-6 stroke-[#E4642A] hover:cursor-pointer"
          />
        </div>
      ),
      width: "20%",
    },
  ];

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "แนวทางการตรวจ/เอกสารที่เกี่ยวข้อง", url: "/inspectionGuide" },
  ];

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename="แนวทางการตรวจ/เอกสารที่เกี่ยวข้อง" />

        <div>
          <div className="flex ">
            <button
              type="button"
              className={`${styles.tabsBar}  ${
                toggle === "guide" ? styles.tabsBarActive : ""
              }`}
              onClick={() => {
                setToggle("guide");
              }}
            >
              แนวทางการตรวจ
            </button>
            <button
              type="button"
              className={`${styles.tabsBar}  ${
                toggle === "document" ? styles.tabsBarActive : ""
              }`}
              onClick={() => {
                setToggle("document");
              }}
            >
              เอกสารที่เกี่ยวข้อง
            </button>
          </div>
          <div>
            {toggle === "guide" ? (
              <>
                <button
                  type="button"
                  className="flex flex-row gap-2 justify-center py-4 px-5 my-4 lg:w-full w-[40%] bg-[#F0F9FF] text-[#233ABE] border-[1px] border-solid border-[#0B88EB] rounded"
                  onClick={() => {
                    nav("/guidelineForm", {
                      state: {
                        type: "add",
                      },
                    });
                  }}
                >
                  <div>
                    <FontAwesomeIcon icon={faPlus} />
                  </div>
                  <div>เพิ่มแนวทางการตรวจ</div>
                </button>
                <p className="font-bold">แนวทางการตรวจ</p>
                <p>
                  1.ท่านสามารถถ่ายทอดประสบการณ์การรักษาหรือแนวทางการตรวจแก่บุคลากรณ์ทางแพทย์ท่านอื่นๆผ่านทางช่องทางนี้ได้
                </p>
                <p>
                  2.คลิกหัวข้อเพื่ออ่านการถ่ายทอดประสบการณ์จากบุคลากรทางการแพทย์ได้ที่นี่
                </p>
                <p>
                  แนวทางการตรวจแลปทั้งหมด{" "}
                  <span className="text-[#0B88EB]">{guideList.length}</span>{" "}
                  รายการ
                  <span className="text-sm ms-2">(ข้อมูลวันที่ {date})</span>
                </p>
                {guideList.length > 0 ? (
                  <>
                    {guideList?.map((item, index) => (
                      <div
                        key={index}
                        className="flex flex-row items-center w-full border-b-[2px] py-4 "
                      >
                        <div className="w-[95%] md:w-full break-all text-pretty">
                          <Link
                            to={`/inspectionGuide/${item.guideline_id}`}
                            style={{ color: "inherit" }}
                          >
                            {item.title}
                          </Link>
                        </div>
                        <div className="w-[5%] md:w-[50px] md:px-4 flex justify-center">
                          {item?.owner?.uid === labUser?.uid ? (
                            <>
                              <FontAwesomeIcon
                                icon={faEdit}
                                color="#00917e"
                                style={{
                                  cursor: "pointer",
                                  marginRight: "10px",
                                }}
                                onClick={() => {
                                  editGuideline(item);
                                }}
                              />

                              <FontAwesomeIcon
                                icon={faTrashCan}
                                color="#FF0000"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  showRemoveGuideline(item);
                                }}
                              />
                            </>
                          ) : null}
                        </div>
                      </div>
                    ))}
                  </>
                ) : null}
                {guideMaxPage > 1 ? (
                  <Pagination
                    page={guidePage}
                    totalpage={guideMaxPage}
                    clickForward={() => {
                      if (guidePage < guideMaxPage) {
                        setGuidePage(guidePage + 1);
                      }
                    }}
                    clickBackward={() => {
                      if (guidePage > 1) {
                        setGuidePage(guidePage - 1);
                      }
                    }}
                  />
                ) : null}
              </>
            ) : null}

            {toggle === "document" ? (
              <>
                <button
                  type="button"
                  className="flex flex-row gap-2 justify-center py-4 px-5 my-4 lg:w-full w-[40%] bg-[#F0F9FF] text-[#233ABE] border-[1px] border-solid border-[#0B88EB] rounded"
                  onClick={() => {
                    setOpenModalUploadFile(true);
                  }}
                >
                  <div>
                    <FontAwesomeIcon icon={faPlus} />
                  </div>
                  <div>เพิ่มไฟล์เอกสาร</div>
                </button>
                <p className="font-bold">เอกสารที่เกี่ยวข้อง</p>
                <p>
                  ท่านสามารถคลิกหรือเพิ่มเอกสารที่เห็นว่าเป็นประโยชน์ต่อบุคลากรทางแพทย์ได้ที่นี่
                </p>
                <p>
                  ทั้งหมด{" "}
                  <span className="text-[#0B88EB]">{documentList.length}</span>{" "}
                  รายการ
                  <span className="text-sm ms-2">(ข้อมูลวันที่ {date})</span>
                </p>
                {documentList.length > 0 ? (
                  <>
                    {documentList?.map((item, index) => (
                      <div
                        key={index}
                        className="flex flex-row items-center w-full border-b-[2px] py-4 "
                      >
                        <div className="w-[80%] md:w-full break-all text-pretty">
                          {item.document_name}
                        </div>
                        <div className="w-[5%] md:w-[50px] md:px-4 flex justify-center">
                          {item?.owner?.uid === labUser?.uid ? (
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              color="#FF0000"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                showRemoveDocument(item);
                              }}
                            />
                          ) : null}
                        </div>
                        <div className="w-[10%] md:w-[100px] md:px-4 flex justify-center">
                          {item.document_file ? (
                            <span
                              className="cursor-pointer hover:text-[#0B88EB]"
                              onClick={() => {
                                window.open(item.document_file);
                              }}
                            >
                              ดาวน์โหลด
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                ) : null}
                {maxPage > 1 ? (
                  <Pagination
                    page={page}
                    totalpage={maxPage}
                    clickForward={() => {
                      if (page < maxPage) {
                        setPage(page + 1);
                      }
                    }}
                    clickBackward={() => {
                      if (page > 1) {
                        setPage(page - 1);
                      }
                    }}
                  />
                ) : null}
              </>
            ) : null}
          </div>
        </div>

        <ModalUploadFileV3
          show={openModalUploadFile}
          title="อัพโหลดไฟล์เอกสาร"
          placeholder="ชื่อเอกสาร"
          titlename="อัพโหลดไฟล์เอกสาร"
          onSubmit={addDocument}
          initialData={null}
          onClose={() => setOpenModalUploadFile(false)}
        />

        {openModalAddData ? (
          <>
            <ModalAddData
              onClose={() => {
                setOpenModalAddData(false);
              }}
              titlename="เพิ่มข้อมูลแนวทางการตรวจ"
              showDetail={showDetail}
              defaultTitle={guidelineTitle}
              defaultDetail={guidelineDetail}
              onSubmit={(e) => {
                if (window.confirm("ยืนยันการบันทึก")) {
                  addGuideline(e.title, e.detail);
                }
              }}
            />
          </>
        ) : null}

        {openModalDeleteDocument ? (
          <ModalDeleteDocument
            onClose={() => {
              setOpenModalDeleteDocument(false);
            }}
            data={documentData}
            onClickData={(item) => {
              removeDocument(item);
            }}
          />
        ) : null}

        {openModalDeleteGuideline ? (
          <ModalDeleteGuideline
            onClose={() => {
              setOpenModalDeleteGuideline(false);
            }}
            data={guidelineData}
            onClickData={(item) => {
              removeGuideline(item);
            }}
          />
        ) : null}
      </div>
    </>
  );
}

export default NewinspectionGuide;
